// extracted by mini-css-extract-plugin
export default {"wrapper":"auth_wrapper__yfQy3","mobile":"auth_mobile__66jgc","tablet":"auth_tablet__2NjlN"};